/**
 * Form selection rule for Building Permit area:
 *
 * When multiple forms exist for a surveyor's company (e.g. Castle Kane), we choose the
 * "current" form to use in the admin Building Permit modal and surveyor-facing print view.
 *
 * Rule: Pick the form with the latest `updatedAt`. This ensures:
 * - Newly created forms (CreatedAt = UpdatedAt) are preferred.
 * - Updated forms (e.g. template refreshed to 2026 version) are preferred over stale ones.
 *
 * Both JobDetailTab and JobFormView must use this same rule for consistency.
 */
export function selectCurrentBuildingPermitForm(forms) {
    if (!forms || forms.length === 0)
        return null;
    const sorted = [...forms].sort((a, b) => {
        const aTime = a.updatedAt ? new Date(a.updatedAt).getTime() : 0;
        const bTime = b.updatedAt ? new Date(b.updatedAt).getTime() : 0;
        return bTime - aTime; // descending: most recent first
    });
    return sorted[0];
}
